// @ts-strict-ignore
import { getCookieSettings } from '@lib/cookies'
import { genericPushToTrackingLayer } from '@lib/data-layer-social-ads/generic-push-to-tracking-layer'
import { useEmarsysTracking } from '@lib/emarsys-tracking/use-emarsys-tracking'
import { useEmarsysScriptIsLoaded, useEmarsysScarabQueueIsLoaded } from '@lib/use-emarsys-store'
import { useRouter } from 'next/router'
import { FC, useEffect } from 'react'
import TagManager from 'react-gtm-module'

const Tracking: FC = () => {
  const router = useRouter()
  const scriptIsLoaded = useEmarsysScriptIsLoaded()
  const scarabQueueIsLoaded = useEmarsysScarabQueueIsLoaded()
  const cookieSettings = getCookieSettings()
  const { isTrackingReady, setDefaultSettings, go } = useEmarsysTracking()
  const { NEXT_PUBLIC_STAGE } = process.env

  useEffect(() => {
    // Hotjar
    if (cookieSettings.includes('analytical') && NEXT_PUBLIC_STAGE === 'production') {
      import('react-hotjar')
        .then((mod) => mod.hotjar)
        .then((hotjar) => hotjar.initialize(283874, 6))
    }

    // Tag manager
    if (
      cookieSettings.includes('analytical') &&
      cookieSettings.includes('personal') &&
      ['staging', 'production'].includes(NEXT_PUBLIC_STAGE) &&
      process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID
    ) {
      TagManager.initialize({ gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID })
    }
  }, []) //eslint-disable-line

  useEffect(() => {
    const emarsysExcludePageTypes = [
      '/p/',
      '_category-page',
      'confirmed',
      '_brand-page',
      '/shopping-cart',
      '/winkelmand',
      '/[...slug]',
    ]
    const homepagePathnames = ['/']
    const isHomepage = homepagePathnames.some((pathname) => router.pathname === pathname)
    genericPushToTrackingLayer('pageview')
    // Fire default emarsys tracking, on all pages except:
    // - Product pages
    // - Category/brand pages
    // - Confirm page
    // - Cart
    // - Homepage
    // - Slug pages (excl: Digital product pages; Content pages; Rich experience pages; Error pages)
    if (
      !isHomepage &&
      emarsysExcludePageTypes.every((pageType) => !router.pathname.includes(pageType)) &&
      scriptIsLoaded &&
      scarabQueueIsLoaded &&
      isTrackingReady
    ) {
      setDefaultSettings()
      go()
    }
  }, [router.asPath, router.pathname, scriptIsLoaded, scarabQueueIsLoaded, isTrackingReady]) //eslint-disable-line

  return null
}

export default Tracking
